import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { ArrowLeft } from 'lucide-react';
interface Slide7Props {
  onNavigate: (slide: number) => void;
}
export function Slide7({
  onNavigate
}: Slide7Props) {
  const menuItems = [{
    title: "Contact Roche Côte d'Ivoire",
    slide: 9
  }, {
    title: 'Prescribing information',
    slide: 11
  }, {
    title: 'Pregnancy considerations',
    slide: 10
  }];
  return <SlideLayout onBack={() => onNavigate(2)} data-id="element-218">
      <div className="w-full max-w-4xl mx-auto space-y-4" data-id="element-219">
        <div className="space-y-1" data-id="element-220">
          <h1 className="text-2xl font-bold text-primary text-center" data-id="element-221">
            Additional resources
          </h1>
          <p className="text-sm text-gray-600 text-center" data-id="element-222">
            Select a topic to learn more:
          </p>
        </div>
        <div className="grid grid-cols-1 gap-3" data-id="element-223">
          {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="bg-white border-2 border-primary rounded-xl p-5 hover:bg-primary hover:text-white transition-all duration-300 hover:shadow-2xl group" data-id="element-224">
              <div className="flex items-center justify-between" data-id="element-225">
                <span className="text-base font-semibold text-left" data-id="element-226">
                  {item.title}
                </span>
                <span className="text-2xl text-accent group-hover:text-highlight transition-colors" data-id="element-227">
                  →
                </span>
              </div>
            </button>)}
        </div>
        <div className="flex justify-center pt-2" data-id="element-228">
          <button onClick={() => onNavigate(2)} className="px-6 py-3 rounded-lg font-semibold bg-highlight text-primary hover:bg-opacity-90 transition-all duration-200 hover:shadow-lg flex items-center gap-2" type="button" data-id="element-229">
            <ArrowLeft className="w-5 h-5" data-id="element-230" />
            Back to main menu
          </button>
        </div>
      </div>
    </SlideLayout>;
}